import React, { useCallback, useMemo, useReducer } from 'react';

import modalConstants    from './modal.constants';
import ModalContext      from './modal.context';
import modalReducer      from './modal.reducer';
import modalInitialState from './modal.state';

/**
 * @type {React.FC}
 */

const ModalProvider = function({
  children,
  value = modalInitialState,
}) {
  const [state, dispatch] = useReducer(modalReducer, value);

  const hideModal = useCallback(() => {
    dispatch({ type: modalConstants.HIDE_MODAL });
  }, [dispatch]);
  const showModal = useCallback((title, body, large = false, className = '', top = '', left = '') => {
    dispatch({
      type: modalConstants.SHOW_MODAL,
      body,
      large,
      title,
      className,
      top,
      left,
    });
  }, [dispatch]);

  const context = useMemo(() => ({
    ...state,
    hideModal,
    showModal,
  }), [hideModal, showModal, state]);

  return (
    <ModalContext.Provider value={context}>
      {children}
    </ModalContext.Provider>
  );
};

export default ModalProvider;